import { formatLotText, formatMeasureValueText } from "@src/components/business-data-display";
import type { ActOfCheckingAvailabilityContent } from "../../../../../api/actOfCheckingAvailability";
import type { StorePlaceRemainder } from "../../../../../api/storePlaces";

/** Возвращает текст ячеек хранения строки АПН. */
export function formatInventoryCells(remainders?: StorePlaceRemainder[]): string {
    if (remainders == null || remainders.length === 0) {
        return "Не задано";
    }

    return remainders.map((item) => item.StorePlace?.Num ?? `Ячейка ${item.SpCode}`).join(", ");
}

/**
 * Признак партийной строки АПН (`ParentLotCode !== 0`). \
 * Для Freor ТСД безпартийные строки показываем в списке disabled; сценарий инвентаризации пока не поддерживается.
 * @param content строка состава АПН
 */
export function isStockPartialInventoryContentLotBased(
    content: Pick<ActOfCheckingAvailabilityContent, "ParentLotCode">,
): boolean {
    return content.ParentLotCode !== 0;
}

/** Возвращает текст партии строки АПН. */
export function formatInventoryLot(content: ActOfCheckingAvailabilityContent): string {
    if (!isStockPartialInventoryContentLotBased(content)) {
        return "Без партии";
    }

    return formatLotText(content.Lot);
}

/**
 * Возвращает признак инвентаризации строки АПН (`IsInventoried`). \
 * Совпадает с признаком «Сканированная» после `contents.updateFactQties`.
 * @param content строка состава АПН
 */
export function isStockPartialInventoryContentInventoried(
    content: Pick<ActOfCheckingAvailabilityContent, "IsInventoried">,
): boolean {
    return content.IsInventoried === true;
}

/** Формирует label поля фактического количества по ячейке. */
export function formatInventoryCellQtyLabel(
    remainder: StorePlaceRemainder,
    content: ActOfCheckingAvailabilityContent,
): string {
    const cellText = remainder.StorePlace?.Num ?? `Ячейка ${remainder.SpCode}`;
    const measureText = formatMeasureValueText("1", content.Measure).replace("1", "").trim();

    return measureText === "" ? `Кол-во факт в ячейке ${cellText}` : `Кол-во факт в ячейке ${cellText} ${measureText}`;
}
